/* eslint-disable import/prefer-default-export */

export enum RfidTypesEnum {
  RFID_FREE = 'RFID_FREE',
  RFID_PREPAID = 'RFID_PREPAID',
  RFID_POSTPAID = 'RFID_POSTPAID',
}
